import { cn } from '@/lib/utils';

/**
 * Returns Tailwind classes for tiered completion score colors.
 * ≤60% red, 61-70% orange, 71-80% yellow, 81-99% lime, 100% seek brand green
 */
export function getCompletionColorClasses(score: number) {
  if (score === 100) return { text: 'text-seek', bar: '[&>div]:bg-seek', bg: 'bg-seek', bgLight: 'bg-seek/15' };
  if (score > 80) return { text: 'text-lime-500', bar: '[&>div]:bg-lime-500', bg: 'bg-lime-500', bgLight: 'bg-lime-500/15' };
  if (score > 70) return { text: 'text-yellow-500', bar: '[&>div]:bg-yellow-500', bg: 'bg-yellow-500', bgLight: 'bg-yellow-500/15' };
  if (score > 60) return { text: 'text-orange-500', bar: '[&>div]:bg-orange-500', bg: 'bg-orange-500', bgLight: 'bg-orange-500/15' };
  return { text: 'text-destructive', bar: '[&>div]:bg-destructive', bg: 'bg-destructive', bgLight: 'bg-destructive/15' };
}
